import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpRequest,
    HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { FUSE_MOCK_API_DEFAULT_DELAY } from '@fuse/lib/mock-api/mock-api.constants';
import { FuseMockApiService } from '@fuse/lib/mock-api/mock-api.service';
import { Observable, delay, of, switchMap, throwError } from 'rxjs';

export const mockApiInterceptor = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const defaultDelay = inject(FUSE_MOCK_API_DEFAULT_DELAY);
    const fuseMockApiService = inject(FuseMockApiService);

    // Try to get the request handler
    const { handler, urlParams } = fuseMockApiService.findHandler(
        request.method.toUpperCase(),
        request.url
    );

    // Pass through if the request handler does not exist
    if (!handler) {
        return next(request);
    }

    // Set the intercepted request on the handler
    handler.request = request;
    console.log('handler: ', handler);

    // Set the url params on the handler
    handler.urlParams = urlParams;

    // Subscribe to the response function observable
    return handler.response.pipe(
        delay(handler.delay ?? defaultDelay ?? 0),
        switchMap((response) => {
            console.log('response: ', response);
            
            // If the response is not an array or does not have the correct structure, throw an error
            if (!response || !Array.isArray(response) || response.length < 2) {
                return throwError(
                    new HttpErrorResponse({
                        error: 'INVALID RESPONSE STRUCTURE',
                        status: 500,
                        statusText: 'ERROR',
                    })
                );
            }

            const [status, body] = response;

            // If the status code is in between 200 and 300, return a success response
            if (status >= 200 && status < 300) {
                return of(
                    new HttpResponse({
                        body,
                        status,
                        statusText: 'OK',
                    })
                );
            }

            // For other status codes, throw an error response
            return throwError(
                new HttpErrorResponse({
                    error: body?.error || 'UNKNOWN ERROR',
                    status,
                    statusText: 'ERROR',
                })
            );
        })
    );
};
